import { List, Panel, Tab, Tabs } from "../../../../src/components/mdx/tabs";
import * as React from 'react';
export default {
  List,
  Panel,
  Tab,
  Tabs,
  React
};